const translateDataSourceSelection = {
  select: 'Select data source(s):',
  select2: 'Select two (2) data sources:',
};

export default translateDataSourceSelection;
